module.exports = __webpack_public_path__ + "img/icon_3.258cbdb6.svg";